module.exports = __webpack_public_path__ + "static/media/caregiver-gif.2c7aab34.gif";